import React, { useState, useRef, useEffect } from 'react';

const ColumnFilterPopup = ({ filter, onChange, onClear, label = 'Left + Order' }) => {
  const [open, setOpen] = useState(false);
  const [localOp, setLocalOp] = useState(filter?.operator || '>=');
  const [localVal, setLocalVal] = useState(filter?.value ?? '');
  const ref = useRef(null);

  const isActive = filter && filter.value !== '';

  // Sync local state when filter changes externally
  useEffect(() => {
    setLocalOp(filter?.operator || '>=');
    setLocalVal(filter?.value ?? '');
  }, [filter]);

  useEffect(() => {
    const handleOut = (e) => {
      if (ref.current && !ref.current.contains(e.target)) setOpen(false);
    };
    document.addEventListener('mousedown', handleOut);
    return () => document.removeEventListener('mousedown', handleOut);
  }, []);

  const handleApply = () => {
    if (localVal !== '') onChange({ operator: localOp, value: localVal });
    setOpen(false);
  };

  const handleClear = () => {
    setLocalOp('>=');
    setLocalVal('');
    onClear();
    setOpen(false);
  };

  return (
    <span ref={ref} style={{ position: 'relative', display: 'inline-flex', marginLeft: 4, verticalAlign: 'middle' }}>
      <button
        onClick={e => { e.stopPropagation(); setOpen(o => !o); }}
        title={isActive ? `Filter: ${filter.operator} ${filter.value}` : 'Filter column'}
        style={{
          display: 'inline-flex',
          alignItems: 'center',
          justifyContent: 'center',
          width: 18,
          height: 18,
          background: isActive ? '#5B965D' : 'transparent',
          border: isActive ? 'none' : '1px solid #c8d0d9',
          borderRadius: 4,
          cursor: 'pointer',
          padding: 0,
          color: isActive ? '#fff' : '#9ba3b0',
          fontSize: 9,
          flexShrink: 0,
        }}
      >
        <i className="fas fa-filter"></i>
      </button>

      {open && (
        <div
          onClick={e => e.stopPropagation()}
          style={{
            position: 'absolute',
            top: 'calc(100% + 6px)',
            left: '50%',
            transform: 'translateX(-50%)',
            background: '#fff',
            border: '1px solid #dde1e7',
            borderRadius: 8,
            boxShadow: '0 4px 16px rgba(0,0,0,0.10)',
            padding: '10px 10px 8px',
            zIndex: 600,
            minWidth: 168,
            whiteSpace: 'normal',
          }}
        >
          <div style={{ fontSize: 10, fontWeight: 700, color: '#9ba3b0', textTransform: 'uppercase', letterSpacing: '0.06em', marginBottom: 7 }}>
            {label}
          </div>
          <div style={{ display: 'flex', gap: 4, marginBottom: 7 }}>
            <select
              value={localOp}
              onChange={e => setLocalOp(e.target.value)}
              style={{ flex: '0 0 46px', padding: '4px 3px', border: '1px solid #dde1e7', borderRadius: 5, fontSize: 13, fontWeight: 700, background: '#fff', cursor: 'pointer', outline: 'none' }}
            >
              <option value=">=">&ge;</option>
              <option value="<=">&le;</option>
              <option value=">">&gt;</option>
              <option value="<">&lt;</option>
              <option value="=">=</option>
            </select>
            <input
              type="number"
              placeholder="value…"
              value={localVal}
              onChange={e => setLocalVal(e.target.value)}
              onKeyDown={e => { if (e.key === 'Enter') handleApply(); if (e.key === 'Escape') setOpen(false); }}
              autoFocus
              style={{ flex: 1, padding: '4px 6px', border: '1px solid #dde1e7', borderRadius: 5, fontSize: 13, outline: 'none', minWidth: 0, boxSizing: 'border-box' }}
            />
          </div>
          <div style={{ display: 'flex', gap: 4 }}>
            <button
              onClick={handleApply}
              style={{ flex: 1, padding: '5px 0', background: '#5B965D', color: '#fff', border: 'none', borderRadius: 5, fontSize: 12, cursor: 'pointer', fontWeight: 500 }}
            >
              Apply
            </button>
            {isActive && (
              <button
                onClick={handleClear}
                style={{ padding: '5px 8px', background: 'none', border: '1px solid #dde1e7', borderRadius: 5, fontSize: 12, cursor: 'pointer', color: '#5a6270' }}
              >
                Clear
              </button>
            )}
          </div>
        </div>
      )}
    </span>
  );
};

export default ColumnFilterPopup;
